module.exports = __webpack_public_path__ + "static/media/Gilroy-ExtraBold.8679ca06.ttf";